// extracted by mini-css-extract-plugin
module.exports = {"container":"Promotions_container__x2oeQ","promotionCard":"Promotions_promotionCard__MJmU_"};